import {Action} from 'redux'
import {CertificateCategoryModel} from '../Model/CertificateCategory'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialCertificateCategoryState: ICertificateCategoryState = {
  data: {
    certificateCategory: [],
    meta: [],
  },
  sortCertificateCategoryData: [],
  CertificateCategoryList: {CertificateCategory: []},
  deleteSuccess: false,
  enableSuccess: false,
  disableSuccess: false,
  singleEnableSuccess: false,
  singleDisableSuccess: false,
  loading: false,
  success: false,
}

export interface ICertificateCategoryState {
  data?: {
    certificateCategory?: CertificateCategoryModel[]
    meta?: {[key: string]: string | number}[]
  }
  sortCertificateCategoryData?: ICertificateCategoryState[]
  CertificateCategoryList?: {CertificateCategory: CertificateCategoryModel[]}
  deleteSuccess?: boolean
  enableSuccess?: boolean
  disableSuccess?: boolean
  singleEnableSuccess?: boolean
  singleDisableSuccess?: boolean
  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: ICertificateCategoryState = initialCertificateCategoryState,
  action: ActionWithPayload<ICertificateCategoryState>
) => {
  switch (action.type) {
    case actionTypes.GET_ALL_CERTIFICATE_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_ALL_CERTIFICATE_CATEGORY_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        CertificateCategoryList: action.payload,
        loading: false,
      }
    }

    case actionTypes.GET_ALL_CERTIFICATE_CATEGORY_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //GET CertificateCategory DATA
    case actionTypes.GET_CERTIFICATE_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_CERTIFICATE_CATEGORY_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_CERTIFICATE_CATEGORY_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Add CertificateCategory
    case actionTypes.ADD_CERTIFICATE_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_CERTIFICATE_CATEGORY_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_CERTIFICATE_CATEGORY_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.RESET_CERTIFICATE_CATEGORY: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    //Update CertificateCategory
    case actionTypes.UPDATE_CERTIFICATE_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_CERTIFICATE_CATEGORY_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_CERTIFICATE_CATEGORY_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Delete
    case actionTypes.DELETE_CERTIFICATE_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_CERTIFICATE_CATEGORY_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_CERTIFICATE_CATEGORY_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    //Enable
    case actionTypes.ENABLE_CERTIFICATE_CATEGORY_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.ENABLE_CERTIFICATE_CATEGORY_SUCCESS: {
      return {
        ...state,
        enableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.ENABLE_CERTIFICATE_CATEGORY_FINISH: {
      return {
        ...state,
        loading: false,
        enableSuccess: false,
      }
    }

    //disable
    case actionTypes.DISABLE_CERTIFICATE_CATEGORY_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.DISABLE_CERTIFICATE_CATEGORY_SUCCESS: {
      return {
        ...state,
        disableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DISABLE_CERTIFICATE_CATEGORY_FINISH: {
      return {
        ...state,
        loading: false,
        disableSuccess: false,
      }
    }
    //Enable
    case actionTypes.SINGLE_ENABLE_CERTIFICATE_CATEGORY_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_ENABLE_CERTIFICATE_CATEGORY_SUCCESS: {
      const changedData: any = action.payload?.data?.certificateCategory
      let newData = state?.data?.certificateCategory?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })
      return {
        ...state,
        data: {...state, meta: state?.data?.meta, CertificateCategory: newData},
        singleEnableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_ENABLE_CERTIFICATE_CATEGORY_FINISH: {
      return {
        ...state,
        singleEnableSuccess: false,
        toggleLoading: false,
      }
    }

    //Disable
    case actionTypes.SINGLE_DISABLE_CERTIFICATE_CATEGORY_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_DISABLE_CERTIFICATE_CATEGORY_SUCCESS: {
      const changedData: any = action.payload?.data?.certificateCategory
      let newData = state?.data?.certificateCategory?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })

      return {
        ...state,
        data: {...state, meta: state?.data?.meta, CertificateCategory: newData},
        singleDisableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_DISABLE_CERTIFICATE_CATEGORY_FINISH: {
      return {
        ...state,
        singleDisableSuccess: false,
        toggleLoading: false,
      }
    }

    // sort
    case actionTypes.SORT_CERTIFICATE_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.SORT_CERTIFICATE_CATEGORY_SUCCESS: {
      return {
        ...state,
        sortCertificateCategoryData: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.SORT_CERTIFICATE_CATEGORY_FINISH: {
      return {
        ...state,
        loading: false,
        success: false,
      }
    }

    case actionTypes.SORT_CERTIFICATE_CATEGORY_RESET: {
      return {
        ...state,
        loading: false,
        success: false,
        sortCertificateCategoryData: [],
      }
    }

    default:
      return state
  }
}
